<template>
  <v-select
    v-model="selectedLocale"
    :items="locales"
    item-title="label"
    item-value="code"
    :label="$t('global.basicTerms.language')"
    variant="outlined"
    density="compact"
    hide-details
    style="max-width: 180px"></v-select>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { useAuth } from '@/composables';
import { useLocaleHelpers } from '@satellite/composables/useLocaleHelpers.js';

const { locale } = useI18n();
const { meRef } = useAuth();
const { setLocaleToLocalStorage } = useLocaleHelpers();

const locales = [
  { code: 'en', label: 'English' },
  { code: 'es-mx', label: 'Español (MX)' },
  { code: 'pt-br', label: 'Portuguese (Brazil)' },
  { code: 'fr-ca', label: 'French Canadian' }
  // Add more as needed
];

const selectedLocale = ref(locale.value);

// Watch for selection changes and update the active i18n locale
watch(selectedLocale, newLocale => {
  locale.value = newLocale;
  setLocaleToLocalStorage(meRef.value.id, newLocale);
});
</script>
